(() => {
  const isRoot = window.location.pathname === "/";
  const isPreview = /(?:^|[?&])preview_theme_id=/.test(window.location.search);
  const isDesignMode = Boolean(window.Shopify?.designMode);

  const redirectIfStaleRoot = () => {
    const theme = window.Shopify?.theme;
    const themeName = String(theme?.name || "");
    const themeId = String(theme?.id || "");
    const isStaleTheme =
      /DrKalla Gold Visual Live 2026-06-11|DrKalla Live v7 0613/.test(themeName) ||
      themeId === "197908824404" ||
      themeId === "197998510420";

    if (!isRoot || isPreview || isDesignMode || !isStaleTheme) return;

    const keep = new URLSearchParams();
    const current = new URLSearchParams(window.location.search);
    ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid"].forEach((key) => {
      const value = current.get(key);
      if (value) keep.set(key, value);
    });

    window.location.replace(`/pages/startseite${keep.toString() ? `?${keep}` : ""}`);
  };

  redirectIfStaleRoot();
  window.setTimeout(redirectIfStaleRoot, 50);
  window.setTimeout(redirectIfStaleRoot, 250);
})();

(() => {
  const normalizeBarberCategoryImage = () => {
    document
      .querySelectorAll('.dk-home-category--barber-herrenpflege .dk-home-category__media img')
      .forEach((image) => {
        image.style.setProperty('aspect-ratio', 'auto', 'important');
        image.style.setProperty('width', '100%', 'important');
        image.style.setProperty('height', 'auto', 'important');
        image.style.setProperty('object-fit', 'contain', 'important');
        image.style.setProperty('object-position', 'center', 'important');
        image.style.setProperty('padding', 'clamp(0.28rem, 0.8vw, 0.75rem)', 'important');
        image.style.setProperty('transform-origin', '50% 72%', 'important');
        image.style.setProperty('transform', 'translateY(-0.12rem) scale(1.1)', 'important');
      });
  };

  normalizeBarberCategoryImage();
  document.addEventListener('DOMContentLoaded', normalizeBarberCategoryImage, { once: true });
  window.addEventListener('load', normalizeBarberCategoryImage, { once: true });
  window.setTimeout(normalizeBarberCategoryImage, 250);
  window.setTimeout(normalizeBarberCategoryImage, 1200);
})();

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (this.slider.classList.contains('slideshow') && !this.announcementBarSlider) {
      this.slider.dataset.autoplay = 'true';
      this.slider.dataset.speed = '4';
    }
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

function drkallaFitAboutVideoPoster() {
  document.querySelectorAll('.dk-about-page__media .deferred-media__poster img').forEach((image) => {
    image.style.width = '100%';
    image.style.height = '100%';
    image.style.objectFit = 'contain';
    image.style.objectPosition = 'center';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', drkallaFitAboutVideoPoster, { once: true });
} else {
  drkallaFitAboutVideoPoster();
}

window.addEventListener('pageshow', drkallaFitAboutVideoPoster);
window.addEventListener('resize', drkallaFitAboutVideoPoster, { passive: true });

function drkallaEnhanceProfiAccessPage() {
  if (!['/pages/als-friseur-registrieren', '/pages/profi'].includes(window.location.pathname)) return;

  const root = document.querySelector('#profi-anfrage.dk-profi-form');
  if (!root || root.dataset.dkProfiGlobalBound === 'true') return;
  root.dataset.dkProfiGlobalBound = 'true';

  const form = root.querySelector('[data-profi-application-form], .dk-profi-form__form');
  const panel = root.querySelector('.dk-profi-form__panel');
  const insertAfter = root.querySelector('[data-profi-status="error"]') || root.querySelector('[data-profi-status="success"]') || root.querySelector('.dk-profi-form__header');

  if (!panel || !form || !insertAfter) return;

  injectProfiAccessStyles();

  function ensureCard(type) {
    const selector = type === 'active' ? '[data-profi-active-card]' : '[data-profi-pending-card]';
    const existing = root.querySelector(selector);
    if (existing) return existing;

    const card = document.createElement('div');
    card.hidden = true;
    card.dataset[type === 'active' ? 'profiActiveCard' : 'profiPendingCard'] = '';
    card.className = type === 'active' ? 'dk-profi-form__active' : 'dk-profi-form__pending';

    if (type === 'active') {
      card.innerHTML = [
        '<p class="dk-profi-form__active-kicker">Profi-Preise aktiv</p>',
        '<h3>Du bist bereits als Profi angemeldet.</h3>',
        '<p>Dein Kundenkonto ist freigeschaltet. Du brauchst keine neue Anfrage einzureichen und kannst direkt mit deinen Profi-Konditionen weiter einkaufen.</p>',
        '<div class="dk-profi-form__active-actions">',
        '<a class="dk-profi-form__active-button dk-profi-form__active-button--primary" href="/">Zum Shop</a>',
        '<a class="dk-profi-form__active-button" href="/pages/konto">Meine Bestellungen</a>',
        '<a class="dk-profi-form__active-button" href="/account/logout">Ausloggen</a>',
        '</div>',
      ].join('');
    } else {
      card.innerHTML = [
        '<p class="dk-profi-form__pending-kicker">Kundenkonto erkannt</p>',
        '<h3>Du bist eingeloggt, aber noch nicht als Profi freigeschaltet.</h3>',
        '<p>Reiche die Anfrage mit Nachweis ein. Sobald wir sie geprüft haben, werden die Profi-Konditionen für dieses Kundenkonto aktiv.</p>',
      ].join('');
    }

    insertAfter.insertAdjacentElement('afterend', card);
    return card;
  }

  function showActive() {
    const activeCard = ensureCard('active');
    const pendingCard = root.querySelector('[data-profi-pending-card]');

    activeCard.hidden = false;
    activeCard.classList.add('is-visible');
    if (pendingCard) {
      pendingCard.hidden = true;
      pendingCard.classList.remove('is-visible');
    }

    form.hidden = true;
    form.setAttribute('aria-hidden', 'true');
  }

  function showPending() {
    const pendingCard = ensureCard('pending');
    const activeCard = root.querySelector('[data-profi-active-card]');

    pendingCard.hidden = false;
    pendingCard.classList.add('is-visible');
    if (activeCard) {
      activeCard.hidden = true;
      activeCard.classList.remove('is-visible');
    }

    form.hidden = false;
    form.removeAttribute('aria-hidden');
  }

  fetch('/apps/drkalla-profi/status?context=profi-page-global', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  })
    .then((response) => {
      if (!response.ok) return null;
      return response.json();
    })
    .then((status) => {
      if (!status || !status.authenticated) return;
      if (status.profi) {
        showActive();
      } else {
        showPending();
      }
    })
    .catch(() => {});
}

function injectProfiAccessStyles() {
  if (document.getElementById('dk-profi-access-global-styles')) return;

  const style = document.createElement('style');
  style.id = 'dk-profi-access-global-styles';
  style.textContent = `
    .dk-profi-form__active,
    .dk-profi-form__pending {
      display: none;
      margin-bottom: clamp(1.8rem, 2.4vw, 2.8rem);
      border-radius: 1.2rem;
      padding: clamp(1.8rem, 3vw, 3rem);
    }

    .dk-profi-form__active.is-visible,
    .dk-profi-form__pending.is-visible {
      display: grid;
      gap: 1.2rem;
    }

    .dk-profi-form__active {
      position: relative;
      overflow: hidden;
      border: 0.1rem solid rgba(211, 189, 136, 0.42);
      background:
        radial-gradient(circle at 12% 0%, rgba(211, 189, 136, 0.22), transparent 24rem),
        linear-gradient(135deg, #0d0d0d 0%, #1e1a13 62%, #443922 100%);
      color: #f8f6f1;
      box-shadow: 0 1.8rem 4.8rem rgba(32, 27, 18, 0.2);
    }

    .dk-profi-form__pending {
      border: 0.1rem solid rgba(168, 145, 98, 0.24);
      background: #fff8ea;
      color: #3a3328;
    }

    .dk-profi-form__active-kicker,
    .dk-profi-form__pending-kicker {
      margin: 0;
      color: #d3bd88;
      font-size: 1.12rem;
      font-weight: 900;
      letter-spacing: 0.12em;
      line-height: 1.2;
      text-transform: uppercase;
    }

    .dk-profi-form__pending-kicker {
      color: #7a632e;
    }

    .dk-profi-form__active h3,
    .dk-profi-form__pending h3 {
      margin: 0;
      font-family: var(--font-heading-family);
      font-size: clamp(2.4rem, 3vw, 3.8rem);
      line-height: 1.06;
      letter-spacing: 0;
    }

    .dk-profi-form__active h3 {
      color: #ffffff;
    }

    .dk-profi-form__pending h3 {
      color: #0b0b0b;
    }

    .dk-profi-form__active p,
    .dk-profi-form__pending p {
      max-width: 76rem;
      margin: 0;
      font-size: 1.46rem;
      line-height: 1.58;
    }

    .dk-profi-form__active p {
      color: rgba(248, 246, 241, 0.78);
    }

    .dk-profi-form__pending p {
      color: #5c5346;
    }

    .dk-profi-form__active-actions {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      margin-top: 0.4rem;
    }

    .dk-profi-form__active-button {
      display: inline-flex;
      min-height: 4.8rem;
      align-items: center;
      justify-content: center;
      border: 0.1rem solid rgba(211, 189, 136, 0.42);
      border-radius: 999rem;
      color: #ffffff;
      font-size: 1.36rem;
      font-weight: 900;
      line-height: 1.1;
      padding: 1.2rem 1.8rem;
      text-align: center;
      text-decoration: none;
    }

    .dk-profi-form__active-button--primary {
      border-color: #d3bd88;
      background: linear-gradient(180deg, #dfcb96 0%, #c5ab6f 100%);
      color: #0b0b0b;
    }

    .dk-profi-form__form[hidden],
    .dk-profi-form__active[hidden],
    .dk-profi-form__pending[hidden] {
      display: none !important;
    }

    @media screen and (max-width: 749px) {
      .dk-profi-form__active-actions {
        display: grid;
      }

      .dk-profi-form__active-button {
        width: 100%;
      }
    }
  `;
  document.head.appendChild(style);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', drkallaEnhanceProfiAccessPage, { once: true });
} else {
  drkallaEnhanceProfiAccessPage();
}

window.addEventListener('pageshow', drkallaEnhanceProfiAccessPage);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

function drkallaEnsureAccountProfileCard() {
  if (window.location.pathname !== '/pages/konto') return;

  const root = document.querySelector('[data-dk-account-orders]');
  if (!root || root.dataset.dkAccountProfileGlobalBound === 'true') return;
  root.dataset.dkAccountProfileGlobalBound = 'true';

  const endpoint = root.dataset.accountEndpoint || '/apps/drkalla-profi/account-data';
  const body = root.querySelector('.dk-account-orders__body');
  const list = root.querySelector('[data-account-orders-list]');
  if (!body || !list) return;

  let style = document.getElementById('dk-account-profile-global-style');
  if (!style) {
    style = document.createElement('style');
    style.id = 'dk-account-profile-global-style';
    style.textContent = `
      .dk-account-orders__profile-card{display:grid;gap:1.4rem;overflow:hidden;border:.1rem solid rgba(168,145,98,.2);border-radius:.8rem;background:radial-gradient(circle at 100% 0%,rgba(231,220,194,.62),transparent 20rem),linear-gradient(135deg,#fff 0%,#fbfaf7 100%);padding:clamp(1.8rem,3vw,2.8rem);box-shadow:0 1.6rem 4rem rgba(54,44,23,.06)}
      .dk-account-orders__profile-head{display:flex;flex-wrap:wrap;gap:1rem;align-items:flex-start;justify-content:space-between}
      .dk-account-orders__profile-head h3{margin:0;color:#151412;font-size:clamp(2rem,2.4vw,2.8rem);line-height:1.06;overflow-wrap:anywhere}
      .dk-account-orders__profile-head p{max-width:58rem;margin:.5rem 0 0;color:#6c6254;font-size:1.35rem;line-height:1.5}
      .dk-account-orders__profile-status{display:inline-flex;align-items:center;min-height:3.2rem;border:.1rem solid rgba(168,145,98,.35);border-radius:999rem;background:#201d18;color:#fffaf0;font-size:1.12rem;font-weight:950;letter-spacing:.04em;line-height:1.15;padding:.7rem 1rem;text-transform:uppercase}
      .dk-account-orders__profile-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:.9rem}
      .dk-account-orders__profile-item{min-width:0;border:.1rem solid rgba(168,145,98,.14);border-radius:.8rem;background:rgba(255,255,255,.72);padding:1.1rem 1.2rem}
      .dk-account-orders__profile-item span{display:block;color:#806324;font-size:1.02rem;font-weight:950;letter-spacing:.08em;line-height:1.2;text-transform:uppercase}
      .dk-account-orders__profile-item strong{display:block;margin-top:.4rem;color:#151412;font-size:1.34rem;line-height:1.35;overflow-wrap:anywhere}
      @media screen and (max-width:640px){.dk-account-orders__profile-grid{grid-template-columns:1fr}}
    `;
    document.head.appendChild(style);
  }

  const ensureCard = () => {
    let profile = root.querySelector('[data-account-profile]');
    if (profile) return profile;

    profile = document.createElement('section');
    profile.className = 'dk-account-orders__profile-card';
    profile.setAttribute('data-account-profile', '');
    profile.setAttribute('aria-live', 'polite');
    profile.setAttribute('aria-atomic', 'true');
    profile.hidden = true;
    list.insertAdjacentElement('beforebegin', profile);
    return profile;
  };

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }[char]));

  const formatDate = (value) => {
    if (!value) return 'Nicht hinterlegt';
    try {
      return new Intl.DateTimeFormat('de-DE', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      }).format(new Date(value));
    } catch {
      return value;
    }
  };

  fetch(`${endpoint}?dk_profile=${Date.now()}`, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  })
    .then((response) => {
      if (!response.ok) return null;
      return response.json();
    })
    .then((data) => {
      if (!data || !data.authenticated || !data.customer) return;
      const customer = data.customer;
      const isProfi = Boolean(customer.isProfi);
      const profile = ensureCard();
      profile.hidden = false;
      profile.innerHTML = `
        <div class="dk-account-orders__profile-head">
          <div>
            <p class="dk-account-orders__kicker">Profil</p>
            <h3>${escapeHtml(customer.displayName || 'Mein Profil')}</h3>
            <p>${isProfi
              ? 'Dein Profi-Status ist aktiv. Einkauf, Bestellungen und Logout bleiben hier im Dr.Kalla Shop.'
              : 'Dein Kundenkonto ist verbunden. Hier siehst du die wichtigsten Profildaten und deine Bestellungen.'}</p>
          </div>
          <span class="dk-account-orders__profile-status">${isProfi ? 'Profi-Preise aktiv' : 'Kundenkonto aktiv'}</span>
        </div>
        <div class="dk-account-orders__profile-grid">
          <div class="dk-account-orders__profile-item"><span>E-Mail</span><strong>${escapeHtml(customer.email || 'Nicht hinterlegt')}</strong></div>
          <div class="dk-account-orders__profile-item"><span>Telefon</span><strong>${escapeHtml(customer.phone || 'Nicht hinterlegt')}</strong></div>
          <div class="dk-account-orders__profile-item"><span>Kontoart</span><strong>${isProfi ? 'Profi-Konto' : 'Standardkonto'}</strong></div>
          <div class="dk-account-orders__profile-item"><span>Kunde seit</span><strong>${escapeHtml(formatDate(customer.createdAt))}</strong></div>
        </div>
      `;
    })
    .catch(() => {});
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', drkallaEnsureAccountProfileCard, { once: true });
} else {
  drkallaEnsureAccountProfileCard();
}

window.addEventListener('pageshow', drkallaEnsureAccountProfileCard);
window.setTimeout(drkallaEnsureAccountProfileCard, 1200);
window.setTimeout(drkallaEnsureAccountProfileCard, 2800);

function drkallaNormalizeAccountOrdersPage() {
  if (window.location.pathname !== '/pages/konto') return;

  const root = document.querySelector('[data-dk-account-orders]');
  if (!root) return;

  const loginUrl = root.dataset.loginUrl || '/customer_authentication/login?return_to=%2Fpages%2Fkonto';
  const profiUrl = root.dataset.profiUrl || '/pages/profi';

  let style = document.getElementById('dk-account-orders-cache-guard-style');
  if (!style) {
    style = document.createElement('style');
    style.id = 'dk-account-orders-cache-guard-style';
    style.textContent = `
      .dk-account-orders__main-stack{display:grid;gap:clamp(2rem,3vw,3.2rem);min-width:0}
      .dk-account-orders h1{font-size:clamp(32px,4.8vw,58px)!important;line-height:1!important}
      .dk-account-orders__summary h2{font-size:clamp(22px,2.4vw,30px)!important}
      @media screen and (min-width:841px){.dk-account-orders__summary{margin-top:clamp(2.5rem,3vw,3.2rem)!important}}
      @media screen and (max-width:840px){.dk-account-orders__main-stack{gap:clamp(1.8rem,4vw,2.6rem)}}
    `;
    document.head.appendChild(style);
  }

  const shell = root.querySelector('.dk-account-orders__shell');
  const layout = shell && shell.querySelector(':scope > .dk-account-orders__layout');
  const hero = shell && shell.querySelector(':scope > .dk-account-orders__hero');
  const body = layout && layout.querySelector(':scope > .dk-account-orders__body');
  const summary = layout && layout.querySelector(':scope > .dk-account-orders__summary');

  if (shell && layout && hero && body && summary && !layout.querySelector(':scope > .dk-account-orders__main-stack')) {
    const mainStack = document.createElement('div');
    mainStack.className = 'dk-account-orders__main-stack';
    layout.insertBefore(mainStack, summary);
    mainStack.appendChild(hero);
    mainStack.appendChild(body);
  }

  const lead = root.querySelector('.dk-account-orders__lead');
  const leadCopy = 'Melde dich an, um Bestellungen, Kontaktdaten und deinen Profi-Status zentral zu sehen. Noch kein Profi-Konto? Über den Profi-Zugang kannst du deine Freischaltung für Profi-Preise anfragen.';
  if (lead && lead.textContent.trim() !== leadCopy) {
    lead.textContent = leadCopy;
  }

  root.querySelectorAll('a[href*="/pages/profi-zugang"]').forEach((link) => {
    link.href = '/pages/profi';
  });

  const pills = root.querySelector('.dk-account-orders__pills');
  if (pills && !pills.textContent.includes('Profi-Preise nach Freischaltung')) {
    pills.innerHTML = `
      <span class="dk-account-orders__pill">Einloggen und Bestellungen sehen</span>
      <span class="dk-account-orders__pill">Profi-Preise nach Freischaltung</span>
      <span class="dk-account-orders__pill">Profi-Zugang beantragen</span>
    `;
  }

  const loggedOut = root.querySelector('[data-account-logged-out]');
  if (loggedOut && !loggedOut.textContent.includes('Profi-Preise werden nach Freischaltung aktiv')) {
    loggedOut.innerHTML = `
      <p class="dk-account-orders__kicker">Login erforderlich</p>
      <h2>Melde dich an, um Konto und Bestellungen zu sehen.</h2>
      <p>Nach dem Login kommst du automatisch zurück hierher. Profi-Preise werden nach Freischaltung aktiv; die Anfrage startest du über den Profi-Zugang.</p>
      <div class="dk-account-orders__summary-actions">
        <a class="dk-account-orders__button" data-account-login href="${loginUrl}">Einloggen</a>
        <a class="dk-account-orders__button dk-account-orders__button--light" href="${profiUrl}">Profi-Zugang beantragen</a>
      </div>
    `;
  }

  const activeSummary = root.querySelector('[data-account-summary]');
  const shouldPatchLoggedOutSummary =
    activeSummary &&
    (root.dataset.accountState === 'logged-out' ||
      activeSummary.textContent.includes('Dein Konto wartet auf den Login') ||
      activeSummary.textContent.includes('Nicht angemeldet'));

  if (shouldPatchLoggedOutSummary && !activeSummary.textContent.includes('Einloggen und Profi-Preise nutzen')) {
    activeSummary.innerHTML = `
      <p class="dk-account-orders__kicker">Login & Profi-Zugang</p>
      <h2>Einloggen und Profi-Preise nutzen.</h2>
      <p>Mit deinem Login siehst du Bestellungen, Profil und Profi-Status. Noch nicht freigeschaltet? Starte deine Anfrage über den Profi-Zugang.</p>
      <div class="dk-account-orders__summary-actions">
        <a class="dk-account-orders__button dk-account-orders__button--light" href="${loginUrl}">Einloggen</a>
        <a class="dk-account-orders__button" href="${profiUrl}">Profi-Zugang beantragen</a>
      </div>
    `;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', drkallaNormalizeAccountOrdersPage, { once: true });
} else {
  drkallaNormalizeAccountOrdersPage();
}

window.addEventListener('load', drkallaNormalizeAccountOrdersPage, { once: true });
window.addEventListener('pageshow', drkallaNormalizeAccountOrdersPage);
window.setTimeout(drkallaNormalizeAccountOrdersPage, 400);
window.setTimeout(drkallaNormalizeAccountOrdersPage, 1200);
window.setTimeout(drkallaNormalizeAccountOrdersPage, 2800);
window.setTimeout(drkallaNormalizeAccountOrdersPage, 5200);

new MutationObserver(() => {
  window.requestAnimationFrame(drkallaNormalizeAccountOrdersPage);
}).observe(document.documentElement, {
  childList: true,
  subtree: true,
});

function drkallaNormalizeAccountEntryPoints() {
  const dashboardPath = '/pages/konto';
  const dashboardUrl = `${window.location.origin}${dashboardPath}`;

  document.querySelectorAll('shopify-account').forEach((account) => {
    const className = String(account.className || '');
    const isKnownAccountControl =
      account.getAttribute('menu') === 'customer-account-main-menu' ||
      className.includes('dk-login-account') ||
      className.includes('dk-menu-account') ||
      className.includes('menu-drawer__account');

    if (!isKnownAccountControl) return;

    const link = document.createElement('a');
    link.href = dashboardPath;
    link.className = className;
    link.innerHTML = account.innerHTML;
    Array.from(account.attributes).forEach((attribute) => {
      if (['class', 'menu', 'href'].includes(attribute.name)) return;
      link.setAttribute(attribute.name, attribute.value);
    });
    if (!link.getAttribute('aria-label')) {
      link.setAttribute('aria-label', 'Kundenbereich ansehen');
    }
    account.replaceWith(link);
  });

  document.querySelectorAll('a[href]').forEach((link) => {
    let url;
    try {
      url = new URL(link.getAttribute('href'), window.location.origin);
    } catch {
      return;
    }

    if (url.origin !== window.location.origin) return;

    if (url.pathname === '/pages/mein-konto') {
      link.href = dashboardPath;
      return;
    }

    if (url.pathname === '/pages/meine-bestellungen') {
      link.href = dashboardPath;
      return;
    }

    if (url.pathname === '/pages/profi-zugang') {
      link.href = '/pages/profi';
      return;
    }

    if (url.pathname === '/account') {
      link.href = dashboardPath;
      return;
    }

    if (
      url.pathname === '/customer_authentication/redirect' &&
      !url.searchParams.has('return_url')
    ) {
      link.href = dashboardPath;
      return;
    }

    if (
      url.pathname === '/customer_authentication/login' &&
      url.searchParams.get('return_to') === '/pages/mein-konto'
    ) {
      url.searchParams.set('return_to', dashboardPath);
      link.href = `${url.pathname}?${url.searchParams.toString()}`;
      return;
    }

    if (
      url.pathname === '/customer_authentication/login' &&
      url.searchParams.get('return_to') === '/pages/meine-bestellungen'
    ) {
      url.searchParams.set('return_to', dashboardPath);
      link.href = `${url.pathname}?${url.searchParams.toString()}`;
      return;
    }

    if (
      url.pathname === '/customer_authentication/redirect' &&
      url.searchParams.get('return_url') === '/pages/mein-konto'
    ) {
      url.searchParams.set('return_url', dashboardPath);
      link.href = `${url.pathname}?${url.searchParams.toString()}`;
      return;
    }

    if (
      url.pathname === '/customer_authentication/redirect' &&
      url.searchParams.get('return_url') === '/pages/meine-bestellungen'
    ) {
      url.searchParams.set('return_url', dashboardPath);
      link.href = `${url.pathname}?${url.searchParams.toString()}`;
      return;
    }

    if (
      url.pathname === '/customer_authentication/login' &&
      !url.searchParams.has('return_to')
    ) {
      link.href = dashboardPath;
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', drkallaNormalizeAccountEntryPoints, { once: true });
} else {
  drkallaNormalizeAccountEntryPoints();
}

window.addEventListener('load', drkallaNormalizeAccountEntryPoints, { once: true });
window.addEventListener('pageshow', drkallaNormalizeAccountEntryPoints);
window.setTimeout(drkallaNormalizeAccountEntryPoints, 600);
window.setTimeout(drkallaNormalizeAccountEntryPoints, 1600);
window.setTimeout(drkallaNormalizeAccountEntryPoints, 3600);

new MutationObserver(() => {
  window.requestAnimationFrame(drkallaNormalizeAccountEntryPoints);
}).observe(document.documentElement, {
  childList: true,
  subtree: true,
});
